import React, { useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { RestrictionsDialogLoader } from '@confluence/restrictions/entry-points/RestrictionsDialog';
import type { ContentRestrictionType } from '@confluence/restrictions/entry-points/types';

import { PublishModalContext } from './PublishModalContext';

export type PermissionsDialogProps = {
	onClose: () => void;
	contentId: string;
	selectedRestrictionType?: ContentRestrictionType;
};

export const PermissionsDialog = ({
	onClose,
	contentId,
	selectedRestrictionType,
}: PermissionsDialogProps) => {
	const {
		restrictionsRestObj,
		setRestrictionsRestObj,
		hasModifiedRestrictions,
		hasScheduledRestrictions,
	} = useContext(PublishModalContext);

	const setRestrictionsDeepCopy = (newVal) => {
		const clone = cloneDeep(newVal);
		setRestrictionsRestObj(clone);
	};
	const preloadRestrictions =
		hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsRestObj : undefined;

	return (
		<RestrictionsDialogLoader
			contentId={contentId}
			submitOverride={setRestrictionsDeepCopy}
			preloadRestrictions={preloadRestrictions}
			preselectRestrictionType={selectedRestrictionType}
			onClose={onClose}
		/>
	);
};
